module.exports = __webpack_public_path__ + "0d775afc953e8c7df1f2827db0f051d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/groups/ShopTechWhite.jpg
// module id = 1292
// module chunks = 0